import {
  AppBar,
  // Button,
  CircularProgress,
  Grid,
  IconButton,
  TableFooter,
  TablePagination,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import Paper from '@material-ui/core/Paper'
import Slide from '@material-ui/core/Slide'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { TransitionProps } from '@material-ui/core/transitions'
import CloseIcon from '@material-ui/icons/Close'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { useApp } from 'contexts/App/appContext'
import { Conversation } from 'models/Conversation'
import React, { useEffect, useState } from 'react'
import { GetConversations } from 'services/ConversationService'
import { formatDateHour, formatPhoneNumber } from 'utils/Date'
import useTranslator from 'utils/hooks/Translator'
import { ModalToPopProps } from '../BuilderModals/types'
import ModalCustomer from '../ModalCustomer'
import * as S from './style'
import './styles.css'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ModalConversations(props: ModalToPopProps) {
  const classes = S.useStyles()
  const botName = localStorage.getItem('@studio:agent') || ''
  const { handleClose } = props
  const { dispatch: dispatchApp } = useApp()
  const [conversations, setConversations] = useState<Conversation[]>([])
  const [openModal, setOpenModal] = useState(false)
  const [customer, setCustomer] = useState('')
  const [loading, setLoading] = useState(false)
  const [customerId, setCustomerId] = useState('')
  const [error, setError] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const { getTranslation } = useTranslator()

  const filteredConversations =
    customerId !== ''
      ? conversations.filter((conversation) => {
          const normalizedSearch = customerId.replace(/\D/g, '')

          if (normalizedSearch === '') return true

          if (
            conversation.customer
              .toLowerCase()
              .includes(customerId.toLowerCase())
          ) {
            return true
          }

          if (conversation.cpf) {
            const normalizedCpf = conversation.cpf.replace(/\D/g, '')
            if (normalizedCpf.includes(normalizedSearch)) {
              return true
            }
          }

          if (conversation.whatsappId) {
            const normalizedWhatsApp = conversation.whatsappId.replace(
              /\D/g,
              '',
            )
            if (normalizedWhatsApp.includes(normalizedSearch)) {
              return true
            }
          }

          return false
        })
      : conversations

  useEffect(() => {
    async function load() {
      setLoading(true)
      const bot_name = botName || ''
      const result = await GetConversations({ bot_name }, dispatchApp)

      if (result.Success) {
        setConversations(result.Data.data)
      } else {
        setConversations([])
      }
      setLoading(false)
    }
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botName])

  const handleDetails = (currentCustomer: string) => () => {
    setCustomer(currentCustomer)
    setOpenModal(true)
  }

  const handleChangePage = (
    event: any,
    newPage: React.SetStateAction<number>,
  ) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (e: {
    target: { value: string | number }
  }) => {
    setRowsPerPage(+e.target.value)
    setPage(0)
  }

  return (
    <>
      <Dialog
        open
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="md"
      >
        <S.ContainerDialog>
          <AppBar>
            <Toolbar>
              <Typography
                variant="h6"
                className={classes.title}
                style={{ flex: 1 }}
              >
                {getTranslation('modal.conversationHistory.title')}
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => {
                  setPage(0)
                  handleClose()
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          {loading ? (
            <Grid
              style={{
                padding: 24,
              }}
            >
              <CircularProgress color="inherit" size={18} />
            </Grid>
          ) : (
            <S.ContentContainer>
              <S.TagsContainer>
                <S.SearchTagContainer>
                  <S.TextContainer>
                    <TextField
                      label={getTranslation('modal.conversationHistory.search')}
                      value={customerId || ''}
                      fullWidth
                      onChange={(e) => setCustomerId(e.target.value)}
                      helperText={error || ''}
                      error={!!error}
                      onBlur={() => setError('')}
                    />
                  </S.TextContainer>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    disabled={customerId === ''}
                  >
                    {getTranslation('search')}
                  </Button> */}
                </S.SearchTagContainer>
              </S.TagsContainer>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  aria-label="simple table"
                  size="medium"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center"></TableCell>
                      <TableCell>
                        {getTranslation('modal.conversationHistory.client')}
                      </TableCell>
                      <TableCell align="center">
                        {getTranslation('modal.conversationHistory.name')}
                      </TableCell>
                      <TableCell align="center">
                        {getTranslation('modal.conversationHistory.cpf')}
                      </TableCell>
                      <TableCell align="center">
                        {getTranslation('modal.conversationHistory.whatsappId')}
                      </TableCell>
                      <TableCell align="center">
                        {getTranslation('modal.conversationHistory.updatedAt')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredConversations.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : filteredConversations
                    ).map((row) => (
                      <TableRow key={row.customer}>
                        <TableCell align="center">
                          <IconButton onClick={handleDetails(row.customer)}>
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell scope="row">{row.customer}</TableCell>
                        <TableCell align="center">{row.name || '-'}</TableCell>
                        <TableCell align="center">{row.cpf || '-'}</TableCell>
                        <TableCell align="center">
                          {formatPhoneNumber(row.whatsappId) || '-'}
                        </TableCell>
                        <TableCell align="center">
                          {formatDateHour(row.updatedAt)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        count={filteredConversations.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={getTranslation(
                          'modal.conversationHistory.linesPerPage',
                        )}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </S.ContentContainer>
          )}
        </S.ContainerDialog>
      </Dialog>
      {openModal && (
        <ModalCustomer
          open={openModal}
          bot_name={botName || ''}
          customer={customer}
          handleClose={() => {
            setOpenModal(false)
          }}
        />
      )}
    </>
  )
}
